/* eslint-disable @typescript-eslint/no-explicit-any */
export const setAltText = (event: any, editor: any, $img: any) => {
    if ($img && $img[0] && $img[0].src) {
        const fullFileName = $img[0].src.split("/")[$img[0].src.split("/").length - 1];
        const fileName = fullFileName.split(".")[0].substr(0, fullFileName.split(".")[0].lastIndexOf("_"));
        $img[0].setAttribute("alt", fileName);
    }
};
